import { ThemeColor } from '@qnpm/q-theme';
import React, { Component } from 'react';
import { toJS } from 'mobx';
import fetch from '@qnpm/react-native-ext-fetch';
import { View, Text, StyleSheet } from 'react-native';
import { Toast } from 'qunar-react-native';
import URLS from '../../Constant/urls';
import Dialog from './components/Dialog';

import PopLayer from './components/popLayer';

export default class MemberPromotion extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            marketing: {},
            visible: false, // 浮层是否展示
            hasShow: false, // 弹框是否展示
            htmlView: '',
            submitDisabled: false // 提交按钮
        };
    }

    componentDidMount() {
        const newData = this.clearMarketingData(this.props.marketing);
        this.setMarketing(newData);
        this.props.onRef && this.props.onRef(this);
    }

    componentWillReceiveProps(nextProps: any) {
        const newData = this.clearMarketingData(nextProps.marketing);
        this.setMarketing(newData);
        nextProps.onRef && nextProps.onRef(this);
    }

    setMarketing = (data: any) => {
        this.setState({
            marketing: data
        })
    }

    onOpenDialog = (index?: number) => {
        const { marketing = {} } = this.state || {};
        // 默认选中每一个产品的第一个乘机人
        //marketing && this.setDefaultMarketSubmitData(marketing, index);

        this.setState({
            visible: !this.state.visible
        });
    };

    clearMarketingData = (data: any) => {
        const productInfoList = data && data.productInfoList || [];
        let productInfoListVisible: boolean[] = [];
        let passengers: any = [];

        if (productInfoList.length > 0) {

            data.clearProductInfoList = this.clearPdcInfoList(productInfoList);
        }

        data.clearProductInfoList && data.clearProductInfoList.forEach((item: any) => {
            let passgenerInfoList = item.passgenerInfoList || [];
            passgenerInfoList.forEach((psgItem: any, j: number) => {

                psgItem.productType = item.productType;

                if (j === 0) {

                    passengers.push(psgItem);

                    item.cardNoShow = psgItem.cardNoShow;
                }
            });

            productInfoListVisible.push(false);

        });

        data.productInfoListVisible = productInfoListVisible;
        data.formData = {
            bookingKey: data.bookingKey,
            orderRecords: passengers // 用于提交数据和弹窗里面默认选中每一个产品的第一个乘机人
        };

        return data || {};
    }

    clearPdcInfoList(data: any) { 
        /**
         * //只保留1&&有乘机人
         * status 1 去绑定
         * status 2 去使用
         * status 3 已过期
         * status 4 已使用
         * status 5 已退订
         * status 6 已失效
         * **/ 
         
        let arr = [];
    
        if(data && data.length > 0) {
            arr = data.filter((item, idx) => item.status === 1 && item.passgenerInfoList && item.passgenerInfoList.length > 0);
        }
    
        return arr;
    }

    // 设置辅营弹框默认选中第一个产品的第一个乘机人
    setDefaultMarketSubmitData(data: any, index: number) {
        const clearProductInfoList = (data && data.clearProductInfoList) || [];
        const productInfoListVisible: boolean[] = [];
        const passengers: any = [];

        // check `clearProductInfoList` size > 0
        if (!clearProductInfoList || clearProductInfoList.length === 0) {
            return {};
        }
        // check `index` in `clearProductInfoList` range.
        if (index < 0 || index >= clearProductInfoList.length) {
            return {};
        }

        if (clearProductInfoList.length > 0) {
            // modify at 2020-12-09. 修改为默认选中第一项
            const item = clearProductInfoList[index];
            if (item) {
                const passgenerInfoList = item.passgenerInfoList || [];
                passgenerInfoList.forEach((psgItem: any, index: number) => {
                    psgItem.productType = item.productType;
                    if (index === 0) {
                        passengers.push(psgItem);
                        item.cardNoShow = psgItem.cardNoShow;
                    }
                });
                productInfoListVisible.push(false);
            }
        }

        data.clearProductInfoList = clearProductInfoList;
        data.productInfoListVisible = productInfoListVisible;
        // 选中产品的`index`
        data.productIndex = index;
        data.formData = {
            bookingKey: data.bookingKey,
            orderRecords: passengers // 用于提交数据和弹窗里面默认选中每一个产品的第一个乘机人
        };
        this.setMarketing(data);
    }

    submit = async (param) => {
        this.setState({
            submitDisabled: true
        });
        const res = await fetch(
            {
                url: URLS.bindPrivilege,
                method: 'POST',
                body: param,
                // requestType: 'form'
            }
        );
        if (res.ret) {
            const { bindResult, details = [] } = res.data || {};

            const html = <View>
                <Text style={styles.alertTitle}>{bindResult}</Text>
                <View>
                    {
                        details.length > 0 && details.map((item: any, idx: number) => {
                            const { productName = '', userName = '' } = item || {};

                            return (
                                <View style={styles.alertItem} key={idx}>
                                    <Text style={styles.alertPdcName}>{productName}</Text>
                                    <Text style={styles.alertName}>(使用人：{userName})</Text>
                                </View>
                            );
                        })
                    }
                </View>
            </View>;

            this.setState({
                hasShow: true,
                visible: false,
                htmlView: html,
                submitDisabled: false
            });

        } else {

            this.setState({
                submitDisabled: false
            });
            Toast.show(res.message || '提交失败，再试试!');
        };
    }

    render() {
        const { orderNo } = this.props || {};
        const { marketing, visible, submitDisabled, hasShow, htmlView } = this.state || {};
        const { productInfoList = [] } = marketing || {};
        const flag = !(Array.isArray(toJS(productInfoList)) && productInfoList.length > 0);
        if (flag) {// 没有返回产品列表不展示模块
            return null;
        }

        return (
            <View>
                <PopLayer
                    marketing={marketing}
                    setMarketing={this.setMarketing}
                    visible={visible}
                    onOpenDialog={this.onOpenDialog}
                    orderNo={orderNo}
                    submit={(param) => {
                        this.submit(param);
                    }}
                    submitDisabled={submitDisabled}
                />
                <Dialog
                    visible={hasShow}
                    title="绑定成功"
                    htmlView={htmlView}

                    onOk={() => {
                        this.setState({
                            hasShow: false
                        });
                        this.props.onRefresh();
                    }} />
            </View>

        );
    }
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 10,
        backgroundColor: '#fff',
        paddingTop: 13,
        paddingBottom: 6
    },
    alertTitle: {
        fontSize: 14,
        color: '#333',
        lineHeight: 20,
        marginBottom: 10
    },
    alertItem: {
        marginBottom: 10,
        flexDirection: 'row',
        alignItems: 'center'
    },
    alertPdcName: {
        lineHeight: 17,
        color: ThemeColor.text2,
        marginRight: 6
    },
    alertName: {
        // backgroundColor: 'red',
        color: '#00BCD4'
    }
});
